import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useSeoMeta } from '../hooks/useSeoMeta';
import { OG_IMAGE_URL } from '../pages/home-redesign/cityLinks';
import LegalPageShell from '../components/LegalPageShell';

const CommunityGuidelines = () => {
  const { t, currentLanguage } = useLanguage();

  useSeoMeta({
    title: t('guidelines.seoTitle'),
    description: t('guidelines.seoDescription'),
    url: 'https://chisme.social/guidelines',
    image: OG_IMAGE_URL,
    locale: currentLanguage === 'en' ? 'en' : 'es',
  });

  return (
    <LegalPageShell
      backLabel={t('guidelines.backHome')}
      title={t('guidelines.title')}
      lastUpdatedLabel={t('guidelines.lastUpdated')}
      lastUpdatedDate={t('guidelines.lastUpdatedDate')}
    >
      <p>{t('guidelines.intro')}</p>

      <h2>{t('guidelines.section1.heading')}</h2>
      <ul>
        {(t('guidelines.section1.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h2>{t('guidelines.section2.heading')}</h2>
      <ul>
        {(t('guidelines.section2.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h2>{t('guidelines.section3.heading')}</h2>
      <ul>
        {(t('guidelines.section3.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h2>{t('guidelines.section4.heading')}</h2>
      <ul>
        {(t('guidelines.section4.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h2>{t('guidelines.section5.heading')}</h2>
      <ul>
        {(t('guidelines.section5.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h2>{t('guidelines.section6.heading')}</h2>
      <ul>
        {(t('guidelines.section6.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h2>{t('guidelines.section7.heading')}</h2>
      <ul>
        {(t('guidelines.section7.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    </LegalPageShell>
  );
};

export default CommunityGuidelines;
